// extracted by mini-css-extract-plugin
module.exports = {"title":"why-devextreme-react-module--title--27pwA"};